import { focusHaloFlush, panelMotion, press } from "@pax/ui";
import { useModelCall } from "@/features/debug/game-data";
import { ModelCallView } from "@/features/debug/Inspector";
import { hostOf } from "@/features/debug/model-call";
import { Failure } from "@/features/evals/components";
import { iconOf, nameOf } from "./dimensions";
import { Mark } from "./pieces";

/** One call, shown the way the game debugger shows it, with a way into that game's debugger. */
export function CallPage({
  callId,
  onOpenCall,
}: {
  callId: string;
  onOpenCall: (callId: string) => void;
}) {
  const detail = useModelCall(callId);
  const call = detail.data;
  const host = call ? hostOf(call) : null;
  return (
    <div className="text-sm">
      <Failure error={detail.error} />
      {detail.isPending && <p className="text-muted-foreground">Reading the call…</p>}
      {call === null && <p className="text-muted-foreground">This call is no longer stored.</p>}
      {call && (
        <>
          <p className="flex flex-wrap items-center gap-x-1.5 gap-y-1 text-muted-foreground">
            <Mark src={iconOf("transport", call.transport)} size="size-3.5" />
            {nameOf("transport", call.transport)}
            {host && (
              <>
                <span>·</span>
                served by
                <Mark src={iconOf("host", host)} size="size-3.5" />
                {host}
              </>
            )}
          </p>
          <div className="mt-4">
            <ModelCallView
              call={call}
              onInspect={target => {
                if (target.kind === "modelCall") onOpenCall(target.call.callId);
              }}
            />
          </div>
          {call.gameId && (
            <div className="mt-9">
              <a
                href={`/play/${call.gameId}/debug?inspect=call:${call.callId}`}
                className={`inline-flex h-8 items-center rounded-full bg-foreground px-3.5 text-sm font-medium text-background ${panelMotion} ${press} ${focusHaloFlush}`}
              >
                Open in the game debugger
              </a>
            </div>
          )}
        </>
      )}
    </div>
  );
}
